import styles from './styles.module.css';
import ClearRoundedIcon from '@mui/icons-material/ClearRounded';
import DataTable from 'components/utils/DataTable';
import Info from 'components/utils/Alert/Info';
import React, { useContext } from 'react';
import GetAppIcon from '@mui/icons-material/GetApp';
import CsvHelper from 'helpers/CsvHelper';
import { saveAs } from 'file-saver';
import { AlertMessagesContext } from 'react-alert-messages';
import { IconButton, Tooltip } from '@mui/material';
import DateTimeHelpers from 'helpers/DateTimeHelpers';
import { useTranslation } from 'react-i18next';

export default function ListDialog({ onClose, rowData, tableHeader, title, emptyDataContent, csvColumns }) {
  const { postAlertMessage } = useContext(AlertMessagesContext);
  const { t: tCommon } = useTranslation('common');
  const { t: tPopup } = useTranslation('popup');

  const getUpdatedData = (data) => {
    return data.map((item) => ({
      ...item,
      inbound: item.quantity > 0 ? item.quantity : null,
      outbound: item.quantity < 0 ? Math.abs(item.quantity) : null,
    }));
  };

  const toCsvBtnPressed = async () => {
    if (!rowData.length) return;
    const csv = CsvHelper.getString(getUpdatedData(rowData), csvColumns);
    const blob = new Blob([csv], {
      type: 'text/csv',
    });
    const dateTime = DateTimeHelpers.getDate(new Date());
    saveAs(blob, `EXPORT-${dateTime}.csv`);

    postAlertMessage({
      text: tPopup('Exported to CSV successfully'),
      type: 'success',
    });
  };

  return (
    <div className={styles.popUp}>
      <div className={styles.contentWrapper}>
        <div className={styles.headSec}>
          <h2 className={styles.editTitle}>{title}</h2>
          <div className={styles.iconGroup}>
            <IconButton size="small" onClick={onClose}>
              <ClearRoundedIcon />
            </IconButton>
          </div>
        </div>
        <div className={styles.tableContent}>
          {rowData.length && rowData ? (
            <DataTable columns={tableHeader} rows={rowData} />
          ) : (
            <Info title={title} content={emptyDataContent} />
          )}
        </div>
        <div className={styles.exportButton}>
          <Tooltip title={tCommon('Export to CSV')}>
            <IconButton>
              <GetAppIcon onClick={toCsvBtnPressed} className={styles.icon} style={{ marginRight: '16px' }} />
            </IconButton>
          </Tooltip>
        </div>
      </div>
    </div>
  );
}
